"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_MAX_SESSION_LAST_ACTIVITY_MINS = exports.INIT_NOT_CALLED = exports.INIT_ONCE_ERROR_MESSAGE = exports.TRACK_EVENT_ERROR_INIT_MESSAGE = exports.CREATE_SESSION_ERROR_INIT_MESSAGE = exports.LAST_ACTIVITY_CACHE_KEY = exports.SESSION_CACHE_KEY = exports.CLIENT_CACHE_KEY = exports.EVENTS_CACHE_KEY = exports.MESSAGE_PREFIX = void 0;
exports.MESSAGE_PREFIX = '@ombori/grid-signals:';
exports.EVENTS_CACHE_KEY = '_OMBORI_GRID_SIGNALS_EVENTS_CACHE';
exports.CLIENT_CACHE_KEY = '_OMBORI_GRID_SIGNALS_CLIENT_CACHE';
exports.SESSION_CACHE_KEY = '_OMBORI_GRID_SIGNALS_SESSION_CACHE';
exports.LAST_ACTIVITY_CACHE_KEY = '_OMBORI_GRID_SIGNALS_LAST_ACTIVITY_CACHE';
exports.CREATE_SESSION_ERROR_INIT_MESSAGE = `${exports.MESSAGE_PREFIX} init must be called before createSession`;
exports.TRACK_EVENT_ERROR_INIT_MESSAGE = `${exports.MESSAGE_PREFIX} init must be called before trackEvent`;
exports.INIT_ONCE_ERROR_MESSAGE = `${exports.MESSAGE_PREFIX} init should only be called once!`;
exports.INIT_NOT_CALLED = `${exports.MESSAGE_PREFIX} init not called!`;
exports.DEFAULT_MAX_SESSION_LAST_ACTIVITY_MINS = 30;
